var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotebookLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4480 5341",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M588 1015c0 69-56 125-125 125s-125-56-125-125V290c0-80 33-153 85-205C476 32 548 0 628 0h3562c80 0 152 33 205 85 53 53 85 125 85 205v4760c0 80-33 152-85 205-53 53-125 85-205 85H628c-80 0-152-33-205-85-52-52-85-125-85-205v-691c0-69 56-124 124-124 69 0 124 56 124 124v691c0 11 5 21 12 29 7 7 18 12 29 12h2777V249H627c-11 0-21 5-29 12-7 7-12 18-12 29v725zM93 3899c-51 0-92-56-92-125s41-125 92-125h670c51 0 92 56 92 125s-41 125-92 125H93zm0-2208c-51 0-92-56-92-125s41-125 92-125h670c51 0 92 56 92 125s-41 125-92 125H93zm0 736c-51 0-92-56-92-125s41-125 92-125h670c51 0 92 56 92 125s-41 125-92 125H93zm0 736c-51 0-92-56-92-125s41-125 92-125h670c51 0 92 56 92 125s-41 125-92 125H93zm3563 1928h535c11 0 21-5 29-12 8-8 12-18 12-29V290c0-11-5-21-12-29-7-7-18-12-29-12h-535v4842z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebookLine);
export default __webpack_public_path__ + "static/media/notebook-line.bdeec10e5c40b66df9496f9be6bb6952.svg";
export { ForwardRef as ReactComponent };